import { render, staticRenderFns } from "./LeaveRequestBreakdownTotalText.vue?vue&type=template&id=a78e9566"
import script from "./LeaveRequestBreakdownTotalText.vue?vue&type=script&lang=js"
export * from "./LeaveRequestBreakdownTotalText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports